import { FileDownloader } from '@/shared/fileDownloader/fileDownloader'
import { TooltipComponent } from './tooltip/tooltip.component'
import { ModalHandler } from './modalHandler/modalHandler'
import { ModalCloseButtonHandler } from './modalCloseButtonHandler/modalCloseButtonHandler'
import { FlashMessageHandler } from '@/shared/flashMessageHandler/flashMessageHandler'

export default () => {
	const initAll = (reinit = false) => {
		initTippy(reinit)
	}

	const initTippy = (reinit = false) => {
		if (reinit) TooltipComponent.destroy()
		TooltipComponent.init()
		FileDownloader.init()
		ModalCloseButtonHandler.init()

		if (!reinit) {
			ModalHandler.init()
			FlashMessageHandler.init()
		}
	}

	return {
		initAll,
		initTippy,
	}
}
